import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons';
import styled from 'styled-components';

import { Link } from '@sorare/routing';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { IconButton } from '@sorare/core/src/atoms/buttons/IconButton';
import { ConditionalWrapper } from '@sorare/core/src/atoms/layout/ConditionalWrapper';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyM, LabelS } from '@sorare/core/src/atoms/typography';
import { ScarcityLabel } from '@sorare/core/src/components/collections/ScarcityLabel';
import { useIntlContext } from '@sorare/core/src/contexts/intl';
import { glossary } from '@sorare/core/src/lib/glossary';

import { Block } from '../ui';

const StyledBlock = styled(Block)`
  background-color: var(--c-black);
  position: sticky;
  top: 0;
  z-index: 1;
`;

type Props = {
  playerName?: string | null;
  rarity?: Rarity | null;
  seasonName?: string;
  teamName?: string | null;
  link?: string;
  onClose?: () => void;
};

export const CollectionHeader = ({
  playerName,
  rarity,
  seasonName,
  teamName,
  link,
  onClose,
}: Props) => {
  const { formatMessage } = useIntlContext();

  return (
    <StyledBlock>
      <Horizontal>
        {!!onClose && (
          <IconButton
            onClick={onClose}
            icon={faChevronLeft}
            color="transparent"
            aria-label={formatMessage(glossary.close)}
          />
        )}
        <ConditionalWrapper wrap={!!link} Wrapper={Link} props={{ to: link! }}>
          <Vertical gap={0}>
            <LabelS as="span" bold>
              <ScarcityLabel scarcity={rarity || Rarity.custom_series} />{' '}
              {seasonName} - {teamName}
            </LabelS>
            <BodyM bold>{playerName}</BodyM>
          </Vertical>
        </ConditionalWrapper>
      </Horizontal>
    </StyledBlock>
  );
};
